import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../../queryKeys";
import { StripeService } from "../../../services/stripe.service";

export const useGetStripePublicKeyQuery = () => {
  return useQuery<{ publicKey: string }, Error>({
    queryKey: [QUERY_CONSTANTS.GET_STRIPE_PUBLIC_KEY],
    queryFn: async () => StripeService.getPublicKey().then((res) => res.data),
  });
};
